import React, { useEffect, useState } from "react";

import ItemsTable from "../components/ItemsTable";
import ModalItem from "../components/ModalItem";
import { useNotification } from "../components/NotificationContext";

import { getItemChanges, normalizeItemDateForApi } from "../utils/items";
import useWsEvents from "../hooks/useWsEvents";
import { addItem as addItemApi, getDatabase, getVoorraad, setProp } from "../api/wsApi";

function Beheer() {
    const [data, setData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [searchInput, setSearchInput] = useState("");
    const [meterFilter, setMeterFilter] = useState("all");
    const [uaFilter, setUaFilter] = useState("all");
    const [sortBy, setSortBy] = useState("meter");
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [voorraad, setVoorraad] = useState({ stock: {} });

    const [modalSaveFunction, setModalSaveFunction] = useState(null);
    const notification = useNotification();

    useEffect(() => {
        fetchDatabase();
        fetchVoorraadData();
    }, []);

    useEffect(() => {
        if (data) {
            updateSearchInput(data);
        }
    }, [data, searchInput, meterFilter, uaFilter, sortBy]);

    useEffect(() => {
        if (showModal && selectedItem && selectedItem.id) {
            setSelectedItem(data.find((item) => item.id === selectedItem.id));
        }
    }, [data]);

    useWsEvents((message) => {
        if (message.event === "databaseUpdated") {
            fetchDatabase();
        }
        if (message.event === "voorraadUpdated") {
            fetchVoorraadData();
        }
    });

    const addItem = (item) => {
        //console.log('Add item', item);

        item.date = normalizeItemDateForApi(item.date);

        addItemApi(item)
            .then(() => {
                fetchDatabase();
                notification("Item added", "success");
            })
            .catch((err) => {
                console.log("Error adding item", err);
                notification("Error adding item", "error");
            });
    };

    const updateDataItem = (item) => {
        const originalItem = data.find((dataItem) => dataItem.id === item.id);
        const changes = getItemChanges(item, originalItem);
        changes.forEach(({ key, value }) => {
            console.log("Update", key, value);
            setProp(key, item.id, value)
                .then(() => {
                    fetchDatabase();
                    notification("Item updated", "success");
                })
                .catch((err) => {
                    console.log("Error updating item", err);
                    notification("Error updating item", "error");
                });
        });
    };

    const fetchDatabase = () => {
        getDatabase()
            .then((data) => {
                setData(data);
            })
            .catch((err) => {
                console.log("Error fetching database", err);
                notification("Error fetching database", "error");
            });
    };

    const fetchVoorraadData = () => {
        getVoorraad()
            .then(setVoorraad)
            .catch((err) => console.log("Error fetching voorraad", err));
    };

    const updateSearchInput = (items) => {
        const words = searchInput.toLowerCase().trim().split(/\s+/).filter(Boolean);
        const filtered = items
            .filter((item) => {
                if (meterFilter !== "all" && item.meter !== Number(meterFilter)) return false;
                if (uaFilter === "ua" && !item.ua) return false;
                if (uaFilter === "active" && item.ua) return false;

                const searchable = [item.name, item.order_number, item.meter, item.date, item.date_delta]
                    .filter((value) => value !== null && value !== undefined)
                    .join(" ")
                    .toLowerCase();
                return words.every((word) => searchable.includes(word));
            })
            .sort((left, right) => {
                if (sortBy === "name") return String(left.name).localeCompare(String(right.name), "nl", { sensitivity: "base" });
                if (sortBy === "order") return Number(left.order_number || 0) - Number(right.order_number || 0);
                if (sortBy === "date") return String(left.date || "9999-99-99").localeCompare(String(right.date || "9999-99-99"));
                return Number(left.meter || 0) - Number(right.meter || 0) || String(left.name).localeCompare(String(right.name), "nl", { sensitivity: "base" });
            });
        setFilteredData(filtered);
    };

    const updateSearchInputValue = (e) => {
        if (e.target.name === "query") setSearchInput(e.target.value);
        if (e.target.name === "meter") setMeterFilter(e.target.value);
        if (e.target.name === "ua") setUaFilter(e.target.value);
        if (e.target.name === "sort") setSortBy(e.target.value);
    };

    return (
        <main>
            <section className="mainWrap">
                <aside>
                    <section className="beheer-filters">
                        <label htmlFor="query">Search</label>
                        <input type="search" id="query" name="query" value={searchInput} placeholder="Name, order number…" onChange={updateSearchInputValue} />
                        <label htmlFor="meter">Meter</label>
                        <select id="meter" name="meter" value={meterFilter} onChange={updateSearchInputValue}>
                            <option value="all">All meters</option>
                            {[...Array(17).keys()].map((meter) => {
                                return (
                                    <option key={meter + 1} value={meter + 1}>
                                        {meter + 1}
                                    </option>
                                );
                            })}
                        </select>
                        <label htmlFor="ua">Assortiment</label>
                        <select id="ua" name="ua" value={uaFilter} onChange={updateSearchInputValue}>
                            <option value="all">All items</option>
                            <option value="active">In assortment</option>
                            <option value="ua">UA only</option>
                        </select>
                        <label htmlFor="sort">Sort by</label>
                        <select id="sort" name="sort" value={sortBy} onChange={updateSearchInputValue}>
                            <option value="meter">Meter, name</option>
                            <option value="name">Name</option>
                            <option value="order">Order number</option>
                            <option value="date">Date</option>
                        </select>

                        <button
                            onClick={() => {
                                const item = {
                                    name: searchInput ? "00" : "",
                                    order_number: searchInput ? searchInput : "0",
                                    img: null,
                                    img_path: null,
                                    date: 0,
                                    date_delta: 1,
                                    ua: false,
                                    meter: 1,
                                };


                                setSelectedItem(item);
                                setModalSaveFunction(() => addItem);
                                setShowModal(true);
                            }}
                            className="hhide"
                        >
                            +
                        </button>
                        <p className="hhide">Add Item</p>
                    </section>
                </aside>

                <section>
                    <div className="beheer-heading">
                        <div>
                            <h1>Beheer</h1>
                            {filteredData && <p>{filteredData.length} of {data.length} items</p>}
                        </div>
                    </div>
                    {filteredData && (
                        <ItemsTable
                            items={filteredData}
                            onClick={(item) => {
                                setSelectedItem(item);
                                setModalSaveFunction(() => updateDataItem);
                                setShowModal(true);
                            }}
                        />
                    )}
                </section>

                {showModal && (
                    <ModalItem
                        item={selectedItem}
                        onClick={() => {
                            setShowModal(false);
                        }}
                        updateDataItem={modalSaveFunction}
                        fetchData={fetchDatabase}
                        voorraad={voorraad.stock}
                    />
                )}
            </section>
        </main>
    );
}

export default Beheer;
